import React from 'react';
import MiniExtendedHoursTable from './MiniExtendedHoursTable';

const MiniExtendedHoursLosers = ({ marketSession, data }) => {
    const sessionName = marketSession === 'pre' ? 'Pre-Market' : 'After-Market';

    return (
        <MiniExtendedHoursTable
            type="losers"
            marketSession={marketSession}
            title={`${sessionName} Losers`}
            linkTo={`/market-movers?tab=${marketSession}-market&${marketSession}market=losers`}
            data={data}
        />
    );
};

export default MiniExtendedHoursLosers;